import { render, staticRenderFns } from "./consultTable.vue?vue&type=template&id=0f125ca8&scoped=true"
import script from "./consultTable.vue?vue&type=script&lang=js"
export * from "./consultTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f125ca8",
  null
  
)

export default component.exports